import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const userInfo = useSelector((state) => state.user.userInfo);
  const loading = useSelector((state) => state.user.loading);

  // Wait for user info to load
  if (loading || !userInfo) {
    return (
      <div className="page-body">
        <div className="container-xl d-flex flex-column justify-content-center">
          <div className="empty">
            <div className="empty-icon">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
            <p className="empty-title">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  // Check admin access
  if (requireAdmin && !userInfo.isAdmin) {
    return <Navigate to="/403" replace />;
  }

  return children;
};
